import { expensesApi } from '../api/expensesApi'
import type { ExpenseUpdateData } from '../schema/expensesSchema'

export const updateExpense = async ({
  expense,
}: {
  expense: ExpenseUpdateData
}) => {
  try {
    const { data } = await expensesApi.updateExpense(expense)
    return data
  } catch (error) {
    console.error(`Error updating expense: `, error)
    throw error
  }
}
